import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy
} from '@angular/core';
import { BrandModule } from '../../brand.module';
import { BaseBrandComponent } from '../../abstract-components/base-brand.component';
import { DialogService } from '~app/app/~shared/services/dialog.service';
import { ResourceFacade } from '~app/app/~store/facades/resource.facade';
import { EventService } from '~app/app/~shared/services/event.service';
import { GlobalEvent } from '~core/models/shared.models';
import { filter, tap } from 'rxjs';
import { PageEvent } from '@angular/material/paginator';
import { BrandCreationDialogComponent } from '../../modals/brand-creation-dialog/brand-creation-dialog.component';

@Component({
  selector: 'brand-list-page',
  standalone: true,
  imports: [BrandModule],
  templateUrl: './brand-list-page.component.html',
  styleUrl: './brand-list-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BrandListPageComponent
  extends BaseBrandComponent
  implements AfterContentInit, OnDestroy
{
  private _dialogService = inject(DialogService);
  private _resourceFacade = inject(ResourceFacade);
  private _eventService = inject(EventService);

  resources$ = this._resourceFacade.resources$;
  currentError$ = this._resourceFacade.currentError$;
  paginationData$ = this._resourceFacade.paginationData$;
  isLoading$ = this._resourceFacade.isLoading$;

  onGlobalRefresh$ = this._eventService.events$.pipe(
    filter((ev: GlobalEvent) => ev.type === 'REFRESH_DATA'),
    tap(() => this.refreshData())
  );

  ngAfterContentInit(): void {
    this._resourceFacade.getData();
  }

  ngOnDestroy(): void {
    this._resourceFacade.resetState();
  }

  refreshData(): void {
    this._resourceFacade.getData({ refresh: true });
  }

  handlePageEvent(e: PageEvent): void {
    this._resourceFacade.setPagination({
      ...(e.pageSize && { itemPerPage: e.pageSize }),
      page: e.pageIndex + 1 || 1
    });
  }

  openAddDialog(): void {
    this._dialogService.open({
      component: BrandCreationDialogComponent,
      fullscreen: true
    });
  }

  onSearch(searchText: string | null): void {
    this._resourceFacade.applyFilters({
      name: searchText ? `like(%${searchText}%)` : null
    });
    this._resourceFacade.getData({ refresh: true });
  }
}
